"use client";

// AssignDriverPanel wraps the existing AssignDialog so the command
// bar can open it without each command duplicating modal scaffolding.
//
// Command-bar panels share a tiny contract: receive the active
// CommandContext + an onClose, render whatever modal/sheet the
// underlying flow already uses, and call onClose when the user
// dismisses or completes the action.
import { AssignDialog } from "@/components/dashboard/assign-dialog";
import type { CommandContext } from "@/lib/commands/types";

export function AssignDriverPanel({
  ctx,
  onClose,
}: {
  ctx: CommandContext;
  onClose: () => void;
}) {
  if (!ctx.loadId) {
    onClose();
    return null;
  }
  return (
    <AssignDialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      deliveryId={ctx.loadId}
      deliveryLabel={ctx.loadId.slice(0, 8)}
    />
  );
}
